export default {
  validateCnpj: (cnpj) => {
    // Remove máscara (pontos, barra, hífen)
    cnpj = cnpj.replace(/[.\-/]/g, '').toUpperCase()

    // Valida tamanho da entrada: CNPJ tem 14 digitos sem mascara
    if (cnpj.length !== 14) {
      return false
    }

    // Rejeita sequências repetidas (ex: 00000000000000, AAAAAAAAAAAAAA)
    if (/^(.)\1+$/.test(cnpj)) {
      return false
    }

    // Valida que os 12 primeiros são alfanuméricos e os 2 últimos são dígitos (0-9)
    if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) {
      return false
    }

    const pesos = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

    // Converte caractere para valor numérico (0-9 = 0-9, A-Z = 10-35)
    const charToValue = (char) => char.charCodeAt(0) - 48

    // Valida primeiro dígito verificador
    let soma = 0

    for (let i = 0; i < 12; i++) {
      soma += charToValue(cnpj[i]) * pesos[i + 1]
    }

    let dv1 = soma % 11
    dv1 = dv1 < 2 ? 0 : 11 - dv1

    if (Number(cnpj[12]) !== dv1) {
      return false
    }

    // Valida segundo dígito verificador
    soma = 0

    for (let i = 0; i < 13; i++) {
      soma += charToValue(cnpj[i]) * pesos[i]
    }

    let dv2 = soma % 11
    dv2 = dv2 < 2 ? 0 : 11 - dv2

    if (Number(cnpj[13]) !== dv2) {
      return false
    }

    return true
  },

  validateCpf: (cpf) => {
    // Valida tamanho da entrada: CPF tem 11 digitos sem mascara
    if (/0{11}/.test(cpf)) {
      return false
    }

    // Valida tamanho da entrada sem caracteres especiais: CPF tem 11 digitos numericos
    if ((cpf = cpf.replace(/[^\d]/g, '')).length !== 11) {
      return false
    }

    // Função para calcular o dígito verificador
    function calcularDigito (cpf, pesoInicial) {
      let soma = 0
      for (let i = 0; i < pesoInicial - 1; i++) {
        soma += parseInt(cpf[i]) * (pesoInicial - i)
      }
      const resto = (soma * 10) % 11
      return resto === 10 ? 0 : resto
    }

    // Calcula os dois dígitos verificadores
    const digito1 = calcularDigito(cpf, 10)
    const digito2 = calcularDigito(cpf, 11)

    // Verifica se os dígitos calculados são iguais aos informados
    return digito1 === parseInt(cpf[9]) && digito2 === parseInt(cpf[10])
  },

  isValidDate: (date) => {
    let [inputDay, inputMonth, inputYear] = date.split('/')
    let isLeapYear = (!(inputYear % 4) && inputYear % 100) || !(inputYear % 400)

    if (inputDay < 1 || inputDay > 31) {
      return false
    }

    if (inputMonth < 1 || inputMonth > 12) {
      return false
    }

    if (inputMonth === '02' && (isLeapYear ? inputDay > 29 : inputDay > 28)) {
      return false
    }

    if (/4|6|9|11/.test(inputMonth) && inputDay > 30) {
      return false
    }

    if (inputYear.length !== 4) {
      return false
    }

    if (inputYear < 2010) {
      return false
    }

    return true
  }
}



// WEBPACK FOOTER //
// ./client/utils/customValidator.js